/**　
 * Color pallet
 */
const Colors = {
    BLUE: '#1A73E8',
    DARK_GREY: '#5F5F5F',
    GOOGLE_BLUE: '#4285F4',
    GREEN: '#00955F',
    HOVER: '#DBDBDB',
    LIGHT_GREY: '#EAEAEA',
    LINK: '#2C75E9',
    MEDIUM_GREY: '#999999',
    OPEN_FULL: '#B1AFAF',
    RED: '#F02B2B',
    TABS: '#EDEDED',
    TABLE_ROW: '#F7F7F7',
    TEXT: '#2C2C2C',
    TEXT_BOLD: '#333333',
    WARN_YELLOW: '#FFC74A',
    WHITE: '#FFFFFF',
    YELLOW: '#FFF200',
    ERROR_RED: '#F44336',
    BLACK: '#000',
    GREY1: '#E8E8E8',
    GREY2: '#707070',
    GREY3: '#D9D9D9',
    PROXIMITY_RED: '#8B1811',
    TERM_GREY: '#939598'
}

export default Colors

export const defaultColor = {
    primary: {
        main: '#888888',
        accent: '#ED1C24',
    },
    secondary: {
        main: '#D9D8D8',
        accent: '#8B1811',
    },
    tertiary: {
        main: '#4B4B4B',
        accent: '#9A9A9A',
    },
    quaternary: {
        main: '#FFFFFF',
        accent: '#F1F1F1',
    },
}

export const skyColor = {
    primary: {
        main: '#888888',
        accent: '#1181B2',
    },
    secondary: {
        main: '#D9D8D8',
        accent: '#1B5872',
    },
    tertiary: {
        main: '#4B4B4B',
        accent: '#8AB5D5',
    },
    quaternary: {
        main: '#FFFFFF',
        accent: '#F1F1F1',
    },
}

export const sunnyColor = {
    primary: {
        main: '#888888',
        accent: '#F0A04B',
    },
    secondary: {
        main: '#D9D8D8',
        accent: '#E57600',
    },
    tertiary: {
        main: '#4B4B4B',
        accent: '#F6C453',
    },
    quaternary: {
        main: '#FFFFFF',
        accent: '#F1F1F1',
    },
}

export const ecoColor = {
    primary: {
        main: '#888888',
        accent: '#6DAF39',
    },
    secondary: {
        main: '#D9D8D8',
        accent: '#3D6755',
    },
    tertiary: {
        main: '#4B4B4B',
        accent: '#A9C25D',
    },
    quaternary: {
        main: '#FFFFFF',
        accent: '#F1F1F1',
    },
}

export const mysticNightColor = {
    primary: {
        main: '#B5B2B2',
        accent: '#ED1C24',
    },
    secondary: {
        main: '#1F1F1F',
        accent: '#8F0000',
    },
    tertiary: {
        main: '#EBEBEB',
        accent: '#800000',
    },
    quaternary: {
        main: '#2B2B2B',
        accent: '#393939',
    },
}
//const stuff = '#000000'
export const customPalette = {
    primary: {
        main: '#888888',
        accent: '#FFF200',
    },
    secondary: {
        main: '#D9D8D8',
        accent: '#888888',
    },
    tertiary: {
        main: '#4B4B4B',
        accent: '#9A9A9A',
    },
    quaternary: {
        main: '#FFFFFF',
        accent: '#F1F1F1',
    }

}
//FFB000
export const iconColorPalette = [
    '#E1D6BE', '#FFF200', '#F0A04B',
    '#E57600', '#ED1C24', '#8F0000',
    '#A9C25D', '#6DAF39', '#3D6755',
    '#8AB5D5', '#1181B2', '#1B5872',
    '#D9D8D8', '#888888', '#393939'
]
